<template>
  <div>
    <h1 class="title is-4">Preferencias del usuario</h1>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">Cuenta de Caja</label>
          <div class="control">
            <div class="select is-fullwidth">
              <select
                name="country"
                v-model="preferences.cuenta"
                @change="savepreferences"
              >
                <option
                  v-for="(cuenta, n3) in filtercuentas"
                  :key="n3"
                  :value="cuenta._id"
                >
                  {{ cuenta.codigo }} - {{ cuenta.nombre }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">Tipo de Impresora</label>
          <div class="control">
            <div class="select is-fullwidth">
              <select
                name="country"
                v-model="preferences.impresora"
                @change="savepreferences"
              >
                <option
                  v-for="(impresora, n4) in impresoras"
                  :key="n4"
                  :value="impresora.codigo"
                >
                  {{ impresora.codigo }} - {{ impresora.nombre }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">Imprime Cambio</label>
          <div class="control">
            <div class="select is-fullwidth">
              <select
                name="country"
                v-model="preferences.incluircambio"
                @change="savepreferences"
              >
                <option
                  v-for="(cambio, n5) in incluircambio"
                  :key="n5"
                  :value="cambio.codigo"
                >
                  {{ cambio.codigo }} - {{ cambio.nombre }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <h1 class="title is-4">Preferencias de la empresa</h1>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label">Tiene cuadre de caja</label>
          <div class="control">
            <div class="select is-fullwidth">
              <select
                name="country"
                v-model="preferencesEmpresa.cuadrecaja"
                @change="savepreferencesempresa"
              >
                <option :value="false">No</option>
                <option :value="true">Si</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">Descripción en la factura</label>
          <div class="control">
            <div class="select is-fullwidth">
              <select
                name="country"
                v-model="preferencesEmpresa.descriptioninvoice"
                @change="savepreferencesempresa"
              >
                <option :value="false">No</option>
                <option :value="true">Si</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
import { mapState } from "vuex";
export default {
  data() {
    return {
      ccostos: [],
      preferencesEmpresa: {
        cuadrecaja: false,
        descriptioninvoice: false,
      },
      preferences: {
        cuenta: "",
        impresora: "",
        incluircambio: "",
      },
      impresoras: [
        {
          codigo: "0",
          nombre: "normal",
        },
        {
          codigo: "1",
          nombre: "tirilla",
        },
        {
          codigo: "2",
          nombre: "tirilla80",
        },
      ],
      incluircambio: [
        {
          codigo: "0",
          nombre: "No",
        },
        {
          codigo: "1",
          nombre: "Si",
        },
      ],
    };
  },
  computed: {
    ...mapState(["bodegas", "empresa", "cuentas"]),
    filtercuentas() {
      const _this = this;
      return _this.cuentas.filter(
        (cuenta) => cuenta.codigo.substr(0, 1) === "1"
      );
    },
  },
  methods: {
    async getuser() {
      try {
        const result = await apiServices.get(`/myuser`);
        if (result) {
          if (
            result.data.companys[this.empresa._id] &&
            result.data.companys[this.empresa._id].preferences
          ) {
            this.preferences =
              result.data.companys[this.empresa._id].preferences;
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async savepreferences() {
      await apiServices.post(`/edituserpreferences`, this.preferences);
    },
    async savepreferencesempresa() {
      const result = await apiServices.post(
        `/asigncashbox`,
        this.preferencesEmpresa
      );
      if (result.data && result.data.ok === 1) {
        console.log("ejecuta el if");
        const empresa = this.empresa;
        empresa.modulos.cuadrecaja = this.preferencesEmpresa.cuadrecaja;
        empresa.modulos.descriptioninvoice =
          this.preferencesEmpresa.descriptioninvoice;
        this.$store.commit("refreshEmpresa", empresa);
      }
    },
    async getccostos() {
      const result = await apiServices.get(`/ccostos`);
      this.ccostos = result.data;
    },
    getDataEmpresa() {
      this.preferencesEmpresa.cuadrecaja = this.empresa.modulos.cuadrecaja;
      this.preferencesEmpresa.descriptioninvoice =
        this.empresa.modulos.descriptioninvoice;
    },
  },
  created() {
    this.getuser();
    this.getccostos();
    this.getDataEmpresa();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/settings/pventa/Settingspventa.vue